<template>
    <h4
        class="mb-5 whitespace-pre-line text-pretty px-2 text-[1.125rem] font-bold leading-[1.3] sm:px-5 sm:text-[1.25rem] lg:text-[1.375rem]"
    >
        <slot />
    </h4>
</template>
